import React, { useState, useEffect } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Table,
  Pagination,
  Segment,
  Grid,
  Card,
  Statistic,
  Loader,
} from "semantic-ui-react";
import { GoArrowUp, GoArrowDown } from "react-icons/go";
import { Container, Content, Center, Input } from "./styled";
import { pb4y as api, pb4yLocal as local } from "../../../../services/apis";
import { datePattern } from "../../../../utils/Utils";
import { getToken } from "../../../../services/auth";
import { Box } from "@material-ui/core";

function ListarPlanos() {
  const [userList, setUserList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalUpgrade, setTotalUpgrade] = useState(0);
  const [totalDowngrade, setTotalDowngrade] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getDate() {
      setLoading(true);
      const searchFilter = search ? `&search=${search}` : "";
      const searchDate = formatDate(dateStart, dateEnd);

      await api
        .get(
          `admin/planModificationRecord?page=${page}${searchFilter}${searchDate}`,
          {
            headers: {
              access_token: `voitto-token ${getToken()}`,
            },
          }
        )
        .then(res => {
          setUserList(res.data.items);
          setTotalUpgrade(res.data.premium);
          setTotalDowngrade(res.data.noPremium);
          setTotalPages(res.data.pages);
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
          console.error(err);
        });
    }
    getDate();
  }, [page, search, dateStart, dateEnd]);

  const getPlan = plan => {
    if (plan === 105091) return "Premium Mensal";
    if (plan === 8888) return "Gratuito";
    if (plan === 110144) return "Estudante";
    if (plan === 113722) return "Premium Anual";
    return "---";
  };

  const formatDate = (start, end) => {
    if (!start || !end) return "";
    return `&dateStart=${start}&dateEnd=${end}`;
  };

  const setPlanUp = user => {
    const newUser = { ...user };
    if (
      user.id_plan_before === 8888 ||
      (user.id_plan_before === 105091 && user.id_plan_after === 113722)
    ) {
      newUser.planUp = true;
    }
    if (
      user.id_plan_after === 8888 ||
      (user.id_plan_before === 113722 && user.id_plan_after === 105091)
    ) {
      newUser.planUp = false;
    }
    return newUser;
  };

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
      <AdminMenu />
        <Content>
          <h1>Histórico de usuários com plano</h1>
          <Segment>
            <Grid stackable columns={2}>
              <Grid.Column>
                <Center>
                  <Card>
                    <Statistic color="green">
                      <Statistic.Value>{totalUpgrade}</Statistic.Value>
                      <Statistic.Label>Upgrade de planos</Statistic.Label>
                    </Statistic>
                  </Card>
                </Center>
              </Grid.Column>
              <Grid.Column>
                <Center>
                  <Card>
                    <Statistic color="red">
                      <Statistic.Value>{totalDowngrade}</Statistic.Value>
                      <Statistic.Label>Downgrade de planos</Statistic.Label>
                    </Statistic>
                  </Card>
                </Center>
              </Grid.Column>
            </Grid>
          </Segment>
          <Grid stackable columns={2}>
            <Grid.Row>
              <Grid.Column>
                <Center>
                  <Input
                    type="search"
                    placeholder="Digite o Id ou email do usuário"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                  />
                </Center>
              </Grid.Column>

              <Grid.Column>
                <Center>
                  <Pagination
                    boundaryRange={0}
                    activePage={page}
                    defaultActivePage={1}
                    onPageChange={(e, f) => setPage(f.activePage)}
                    firstItem={null}
                    lastItem={null}
                    totalPages={totalPages}
                  />
                </Center>
              </Grid.Column>
            </Grid.Row>

            <Grid.Column>
              <Center>
                <div className="ui fluid" style={{ width: "50%" }}>
                  <strong>De:</strong>
                  <div className="ui input fluid">
                    <input
                      type="date"
                      onChange={e => setDateStart(e.target.value)}
                      value={dateStart}
                    />
                  </div>
                </div>
                <div
                  className="ui fluid"
                  style={{ marginLeft: "16px", width: "50%" }}
                >
                  <strong>Até:</strong>
                  <div className="ui input fluid">
                    <input
                      type="date"
                      onChange={e => setDateEnd(e.target.value)}
                      value={dateEnd}
                    />
                  </div>
                </div>
              </Center>
            </Grid.Column>
          </Grid>

          <Table stackable>
            <Table.Header>
              <Table.HeaderCell style={{ width: "5%" }}>
                <Center>ID</Center>
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: "15%" }}>
                <Center>ID Usuário</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>E-mail</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Plano atual</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Cupom</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Data</Center>
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: "15%" }}>
                <Center>Status Plano</Center>
              </Table.HeaderCell>
            </Table.Header>

            {loading ? (
              <Loader active={loading} />
            ) : (
              userList.length !== 0 &&
              userList.map(user => {
                const newUser = setPlanUp(user);

                return (
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell style={{ width: "5%" }}>
                        <Center>{newUser.id}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: "15%" }}>
                        <Center>{newUser.id_user}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{newUser.email_user}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: "15%" }}>
                        <Center>{getPlan(newUser.id_plan_after)}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{newUser.cupom}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{datePattern(newUser.date_sys)}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: "15%" }}>
                        <Center>
                          {newUser.planUp ? (
                            <GoArrowUp size={26} color="5BC236" />
                          ) : (
                            <GoArrowDown size={26} color="D02A18" />
                          )}
                        </Center>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                );
              })
            )}
          </Table>
        </Content>
      </Box>
    </Box>
  );
}

export default ListarPlanos;
